/**
 * B2B cart → custom checkout navigation (drawer, cart page, add-to-cart notification).
 */
(function () {
  var CHECKOUT_SELECTORS = '#MainCart-Checkout, #CartDrawer-Checkout, #cart-notification-checkout';

  function getCartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return String(window.Shopify.routes.root);
    }
    if (window.routes && window.routes.root_url) {
      return String(window.routes.root_url);
    }
    return '/';
  }

  function resolveCheckoutUrl(href) {
    var url = (href || '').trim();
    if (!url && window.routes && window.routes.b2b_checkout_url) {
      url = String(window.routes.b2b_checkout_url);
    }
    if (!url) {
      url = '/pages/custom-checkout';
    }
    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    var root = getCartRoot();
    if (url.charAt(0) === '/' && root && root !== '/') {
      var rootTrimmed = root.replace(/\/$/, '');
      if (rootTrimmed && url.indexOf(rootTrimmed) !== 0) {
        return rootTrimmed + url;
      }
    }
    return url;
  }

  function findCartNote(link) {
    var drawer = link.closest('cart-drawer');
    if (drawer) {
      var drawerNote = drawer.querySelector('#CartDrawer-Note');
      if (drawerNote) return drawerNote;
    }
    return document.getElementById('Cart-note');
  }

  function goToCheckout(link) {
    var href = resolveCheckoutUrl(link.getAttribute('href'));
    var noteEl = findCartNote(link);
    var note = noteEl ? noteEl.value : '';
    var updateUrl = (window.routes && window.routes.cart_update_url) || getCartRoot() + 'cart/update.js';

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note || '' }),
    })
      .catch(function () {})
      .finally(function () {
        window.location.assign(href);
      });
  }

  function hydrateCheckoutHrefs() {
    var fallback = resolveCheckoutUrl('');
    document.querySelectorAll(CHECKOUT_SELECTORS).forEach(function (link) {
      var href = (link.getAttribute('href') || '').trim();
      if (!href) {
        link.setAttribute('href', fallback);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateCheckoutHrefs);
  } else {
    hydrateCheckoutHrefs();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(CHECKOUT_SELECTORS);
    if (!link || link.hasAttribute('disabled')) return;
    event.preventDefault();
    goToCheckout(link);
  });
})();
